











































import NotifyMixin from '@/plugins/mixins/NotifyMixin'
import { UwInput } from '@ultraware/vee-form-handler'
import SelectDateRange from '@/components/SelectDateRange.vue'
import { date, QBtn, QIcon, QSpinnerGears, QTooltip } from 'quasar'
import { downloadFile } from 'src/domains/file/'
import { IQSelectOptions } from 'src/quasar-types'
import { ValidationObserver } from 'vee-validate'
import { Component, Mixins } from 'vue-property-decorator'
import { getSchoolYearOptions } from 'src/domains/date/schoolYearOptions'

@Component({
  components: {
    QBtn,
    QSpinnerGears,
    QIcon,
    QTooltip,
    SelectDateRange,
    UwInput,
    ValidationObserver,
  },
})
export default class ExcelReportForm extends Mixins(NotifyMixin) {
  public startDate = ''
  public endDate = ''
  public schoolYearSelection = ''
  public today: Date = new Date()
  public autoBindLastXhrErrorResponse = false
  public schoolYearOptions = getSchoolYearOptions(this.today)
  public $refs!: {
    validationObserver: InstanceType<typeof ValidationObserver>
  }

  public updateBothDates(selected: IQSelectOptions<string>): void {
    const dates = selected.value.split('_')
    this.startDate = date.formatDate(date.adjustDate(new Date(dates[0]), { month: 8, date: 1 }), 'DD-MM-YYYY')
    this.endDate = date.formatDate(date.adjustDate(new Date(dates[1]), { month: 7, date: 31 }), 'DD-MM-YYYY')
  }

  public async submit(raw: boolean): Promise<void> {
    const result = await this.$refs.validationObserver.validate()
    if (!result) return

    const startDate = date.extractDate(this.startDate, 'DD-MM-YYYY')
    const endDate = date.extractDate(this.endDate, 'DD-MM-YYYY')
    if (startDate.getTime() > endDate.getTime()) {
      this.$refs.validationObserver.setErrors({
        endDate: ['De "Tot" datum moet ná de "Van" datum liggen.'],
      })
      return
    }

    this.$q.loading.show({
      spinner: QSpinnerGears,
      spinnerColor: 'primary',
    })

    const formattedStartDate = startDate.toISOString().replace('+', '%2B')
    const formattedEndDate = endDate.toISOString().replace('+', '%2B')

    const url = 'report/csv?start_date=' + formattedStartDate + '&end_date=' + formattedEndDate + '&raw=' + raw
    const fileName = this.startDate + ' - ' +
      this.endDate + ' Report.csv'

    try {
      await downloadFile(url, fileName, 60000)
    } catch (error) {
      this.catchErrorMessage(error)
    }

    this.$q.loading.hide()
    document.documentElement.scrollTop = 0
  }
}
